import { useEffect, useRef } from 'react'
import { SocialScheme } from 'utils/constants'

interface Props {
	action: string
	socialProvider?: SocialScheme | null
	handleProcess?: any
	afterOpenPopup?: any
	afterClosePopup?: any
	setSocialProvider?: (...args: any) => any
}

export function SocialProcessPopup({
	action,
	socialProvider = null,
	handleProcess = null,
	afterOpenPopup,
	afterClosePopup,
	setSocialProvider,
}: Props) {
	const timer = useRef<ReturnType<typeof setInterval>>()

	useEffect(() => {
		return () => {
			clearPopup()
		}
	}, [])

	useEffect(() => {
		if (socialProvider) {
			let tProvider = socialProvider as string
			if (socialProvider === SocialScheme.Youtube) {
				tProvider = 'google'
			}
			if (socialProvider === SocialScheme.AmazonMusic) {
				tProvider = 'amazon'
			}
			window.onstorage = () => handleProcess(socialProvider)
			const w = openPopupOAuth(tProvider)
			timer.current = setInterval(() => {
				if (w?.closed) {
					clearInterval(timer.current)
					afterClosePopup?.()
				}
			}, 200)
			afterOpenPopup?.()
			setSocialProvider?.(null)
		}
	}, [socialProvider])

	const clearPopup = () => {
		window.onstorage = null
		setSocialProvider?.(null)
		if (timer.current) {
			clearInterval(timer.current)
			afterClosePopup?.()
		}
	}

	const openPopupOAuth = (provider: string) => {
		return window.open(
			`${import.meta.env.VITE_BASE_URL}/api/auth/${provider}/${action}?redirect_uri=${
				import.meta.env.VITE_REDIRECT_URL
			}/auth/process`,
			'popUpWindow',
			'height=500,width=400,left=100,top=100,toolbar=no,menubar=no,location=no,directories=no,status=no'
		)
	}

	return null
}
